import { Box } from "@mui/material";
import { UrlPortalProveedores } from "../../../services/apirest";
import { enviarmails } from "../../../services/services";
import { formatCuit } from "../pago_proveedores/utils";
import { normalizarCuit } from "./altaProveedores.service";
import { obtenerPlantillaCorreo } from "./plantillasCorreo.service";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const esEmailValido = (valor) =>
  EMAIL_REGEX.test(String(valor || "").trim());

export const obtenerEmailMaestro = (proveedor) =>
  String(proveedor?.email || "").trim();

export const resolverEmailParaEnvio = (emailMaestro, emailManual) =>
  emailMaestro || String(emailManual || "").trim();

export const emailListoParaEnvio = (emailMaestro, emailManual) =>
  Boolean(emailMaestro) || esEmailValido(emailManual);

export const helperTextCorreoAlta = (
  <Box
    component="span"
    sx={{ fontWeight: 800, color: "text.primary", display: "inline" }}
  >
    Este correo se utilizará para AVISAR AL PROVEEDOR que se le dio de alta en
    el portal.
  </Box>
);

export const helperTextCorreoBaja =
  "Este correo se utilizará para avisar al proveedor que se le dio de baja en el portal.";

const bloqueDatosProveedor = (cuitNorm, razonSocial) => `
  <p><strong>CUIT:</strong> ${formatCuit(cuitNorm)}</p>
  ${razonSocial ? `<p><strong>Razón social:</strong> ${razonSocial}</p>` : ""}
`;

const armarUrlCambiarContrasena = (setupToken) => {
  const params = new URLSearchParams({ token: setupToken });
  return `${UrlPortalProveedores}/cambiar-contrasena?${params.toString()}`;
};

const bloqueAccesoPortalAlta = (setupToken) => {
  if (!setupToken) {
    return `<p>Puede acceder al portal en: <a href="${UrlPortalProveedores}">${UrlPortalProveedores}</a></p>`;
  }
  const url = armarUrlCambiarContrasena(setupToken);
  return `
    <p><a href="${url}">Haga clic aquí para definir su contraseña</a></p>
    <p>En su primer ingreso, deberá cambiar la contraseña para continuar.</p>
  `;
};

const bloqueAccesoPortal = (cuitNorm) => {
  const contrasena = `${cuitNorm}ABC`;
  return `
    <p><strong>Contraseña:</strong> ${contrasena}</p>
    <p>Puede acceder al portal en: <a href="${UrlPortalProveedores}">${UrlPortalProveedores}</a></p>
  `;
};

const escapeHtml = (valor) =>
  String(valor ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

export const armarCuerpoMailAltaDesdePlantilla = (
  plantilla,
  cuit,
  razonSocial = "",
  setupToken = ""
) => {
  const cuitNorm = normalizarCuit(cuit);
  const datos = `<p><strong>Razón social:</strong> ${escapeHtml(
    razonSocial || ""
  )}</p><p><strong>CUIT:</strong> ${escapeHtml(formatCuit(cuitNorm))}</p>`;
  return `${plantilla?.texto_arriba || ""}${datos}${bloqueAccesoPortalAlta(
    setupToken
  )}${plantilla?.texto_abajo || ""}`;
};

export const armarCuerpoMailAltaInicial = (cuit, razonSocial = "", setupToken = "") => {
  const cuitNorm = normalizarCuit(cuit);
  return `
    <p>Estimado proveedor:</p>
    <p>Nos encontramos en un proceso de actualización de nuestro sistema de gestión.</p>
    <p>Como parte de esta implementación, se le dio de alta en el Portal de Proveedores para que pueda cargar la documentación e información requerida.</p>
    <p>Sus datos de acceso son:</p>
    <p>CUIT: ${formatCuit(cuitNorm)}</p>
    ${bloqueAccesoPortalAlta(setupToken)}
    <p>Saludos cordiales.</p>
  `;
};

export const armarCuerpoMailReactivacionDesdePlantilla = (
  plantilla,
  cuit,
  razonSocial = ""
) => {
  const cuitNorm = normalizarCuit(cuit);
  const datos = `<p><strong>Razón social:</strong> ${escapeHtml(
    razonSocial || ""
  )}</p><p><strong>CUIT:</strong> ${escapeHtml(formatCuit(cuitNorm))}</p>`;
  const url = UrlPortalProveedores;
  const acceso = `<p><strong>Contraseña:</strong> ${escapeHtml(
    `${cuitNorm}ABC`
  )}</p><p>Puede acceder al portal en: <a href="${escapeHtml(
    url
  )}">${escapeHtml(url)}</a></p>`;
  return `${plantilla?.texto_arriba || ""}${datos}${acceso}${
    plantilla?.texto_abajo || ""
  }`;
};

export const armarCuerpoMailReactivacion = (cuit, razonSocial = "") => {
  const cuitNorm = normalizarCuit(cuit);
  return `
    <p>Le informamos que se reactivó su acceso al portal de proveedores.</p>
    ${bloqueDatosProveedor(cuitNorm, razonSocial)}
    ${bloqueAccesoPortal(cuitNorm)}
  `;
};

export const armarCuerpoMailBajaDesdePlantilla = (
  plantilla,
  cuit,
  razonSocial = ""
) => {
  const cuitNorm = normalizarCuit(cuit);
  const datos = `<p><strong>Razón social:</strong> ${escapeHtml(
    razonSocial || ""
  )}</p><p><strong>CUIT:</strong> ${escapeHtml(formatCuit(cuitNorm))}</p>`;
  const url = UrlPortalProveedores;
  const link = `<p>Su acceso al portal <a href="${escapeHtml(
    url
  )}">${escapeHtml(url)}</a> quedó suspendido.</p>`;
  return `${plantilla?.texto_arriba || ""}${datos}${link}${
    plantilla?.texto_abajo || ""
  }`;
};

export const armarCuerpoMailBaja = (cuit, razonSocial = "") => {
  const cuitNorm = normalizarCuit(cuit);
  return `
    <p>Le informamos que se le dio de baja en el portal de proveedores.</p>
    ${bloqueDatosProveedor(cuitNorm, razonSocial)}
    <p>Su acceso al portal <a href="${UrlPortalProveedores}">${UrlPortalProveedores}</a> quedó suspendido.</p>
  `;
};

const ASUNTOS_CORREO = {
  "alta-inicial": "Alta en el portal de proveedores",
  reactivacion: "Reactivación en el portal de proveedores",
  baja: "Baja en el portal de proveedores",
};

const CUERPOS_CORREO = {
  "alta-inicial": armarCuerpoMailAltaInicial,
  reactivacion: armarCuerpoMailReactivacion,
  baja: armarCuerpoMailBaja,
};

export const enviarNotificacionEstadoProveedor = async ({
  email,
  cuit,
  razonSocial = "",
  tipo,
  setupToken = "",
}) => {
  let asunto = ASUNTOS_CORREO[tipo];
  let cuerpo =
    tipo === "alta-inicial"
      ? armarCuerpoMailAltaInicial(cuit, razonSocial, setupToken)
      : CUERPOS_CORREO[tipo](cuit, razonSocial);

  if (tipo === "alta-inicial" || tipo === "baja" || tipo === "reactivacion") {
    const codigo =
      tipo === "baja" ? "baja" : tipo === "reactivacion" ? "reactivacion" : "alta";
    try {
      const plantilla = await obtenerPlantillaCorreo(codigo);
      if (plantilla?.asunto) {
        asunto = String(plantilla.asunto).trim();
        cuerpo =
          codigo === "baja"
            ? armarCuerpoMailBajaDesdePlantilla(plantilla, cuit, razonSocial)
            : codigo === "reactivacion"
              ? armarCuerpoMailReactivacionDesdePlantilla(
                  plantilla,
                  cuit,
                  razonSocial
                )
              : armarCuerpoMailAltaDesdePlantilla(
                  plantilla,
                  cuit,
                  razonSocial,
                  setupToken
                );
      }
    } catch (error) {
      console.error(
        `No se pudo leer la plantilla de ${codigo}, se usa el texto base:`,
        error
      );
    }
  }

  await enviarmails(email, asunto, cuerpo);
};
